class ManageReportAccessController {
    constructor() {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.report = null;
            this.reportId = -1;
            this.reportName = '';
            this.reportDescription = '';
            this.updateState = 'init';
            this.report = this.resolve.report;
            this.reportId = this.report.Id;
            this.reportName = this.report.Name;
            this.reportDescription = this.report.Description;
        };
        this.cancel = () => {
            if (this.updateState === 'init') {
                // Cancel the page without any changes
                this.dismiss();
            }
            else {
                this.close({ $value: 'update' });
            }
        };
    }
}
angular.module('app').component('manageReportAccessModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Reports/ReportAccess/manage-report-access.tpl.html',
    controllerAs: 'vm',
    controller: ManageReportAccessController
});
